<template>
    <v-card rounded="t-xl">
      <v-list class="bg-surface">
        <v-list-item v-for="item in $store.state.info.metas" :key="`bcard`+item.id">
          <template v-slot:prepend v-if="item.meta_type == 'text'">
            <img height="30" :src="'https://limoapp.ir/business_card/images/'+item.meta_icon+'.png'" class="mx-3" />
          </template>
  
          <v-list-item-title v-if="item.meta_type == 'text'">
            <div v-if="item.meta_btn_type == 'tel'" class="business-card-list-item-text">
              <a style="text-wrap: auto;color: inherit" :href="'tel:'+item.meta_value">{{ item.meta_text }}</a>
              <v-btn size="small" elevation="5" color="primary text-white" class="mx-3" rounded :href="'tel:'+item.meta_value">
                {{ $t('call_now') }}
              </v-btn>
            </div>
  
            <div v-else-if="item.meta_btn_type == 'url'" class="business-card-list-item-text">
              <a style="text-wrap: auto;color: inherit" target="_blank" :href="item.meta_value">{{ item.meta_text }}</a>
              <v-btn size="small" elevation="5" color="primary text-white" class="mx-3" rounded target="_blank" :href="item.meta_value">
                {{ $t('open_link') }}
              </v-btn>
            </div>
  
            <div v-else-if="item.meta_btn_type == 'copy'" class="business-card-list-item-text">
              <span style="text-wrap: auto;">{{ item.meta_text }}</span>
              <v-btn size="small" elevation="5" color="primary text-white" class="mx-3" rounded @click="copyToClipboard(item.meta_value)">
                {{ $t('copy_address') }}
              </v-btn>
            </div>
  
            <div v-else>
              <span style="text-wrap: auto;">{{ item.meta_text }}</span>
            </div>
          </v-list-item-title>
  
          <template v-else-if="item.meta_type == 'longtext'">
            <CardComponent class="mt-5" :label="item.meta_text">
              <div v-html="item.meta_value" class="text-justify pa-2"></div>
            </CardComponent>
          </template>
  
          <template v-else-if="item.meta_type == 'location'">
            <CardComponent class="mt-5 text-center" :label="item.meta_text">
              <v-btn elevation="5" color="primary text-white" rounded :href="'https://www.google.com/maps/@'+item.meta_value+',15z'" target="_blank" class="mx-3">
                <img height="30" :src="'https://limoapp.ir/business_card/images/google_maps.png'" class="mx-1" />
                {{ $t('google_maps') }}
              </v-btn>
              <v-btn elevation="5" color="primary text-white" rounded :href="'https://neshan.org/maps/routing/car/destination/'+item.meta_value" target="_blank" class="mx-3">
                <img height="30" :src="'https://limoapp.ir/business_card/images/neshan.png'" class="mx-1" />
                {{ $t('neshan') }}
              </v-btn>
            </CardComponent>
          </template>
  
          <template v-else-if="item.meta_type == 'sound'">
            <CardComponent class="mt-5" :label="item.meta_text">
              <audio style="width: 100%;" ref="audio" :src="$store.state.fileBaseUrl+item.meta_value" controls></audio>
            </CardComponent>
          </template>
  
          <template v-else-if="item.meta_type == 'aparat'">
            <CardComponent class="mt-5" :label="item.meta_text">
              <div v-html="item.meta_value"></div>
            </CardComponent>
          </template>
  
          <template v-else-if="item.meta_type == 'image'">
            <CardComponent class="mt-5" :label="item.meta_text">
              <v-carousel>
                <v-carousel-item
                  v-for="img in item.meta_value.split('|')" :key="img"
                  :src="$store.state.fileBaseUrl+img"
                  cover
                />
              </v-carousel>
            </CardComponent>
          </template>
        </v-list-item>
      </v-list>
    </v-card>
  </template>
  
  <script>
  import CardComponent from '@/components/CardComponent.vue'
  
  export default {
    name: "BusinessCardList",
    components: {
      CardComponent,
    },
    data() {
      return {
        tab: "about",
        selectedCategory: "all",
      }
    },
    methods: {
      copyToClipboard(text) {
        const textarea = document.createElement('textarea')
        textarea.value = text
        document.body.appendChild(textarea)
        textarea.select()
        textarea.setSelectionRange(0, 99999)
        document.execCommand('copy')
        document.body.removeChild(textarea)
        alert(this.$t('copied_message') + '\n' + text)
      },
    },
  }
  </script>
  
  <style>
  .business-card-list-item-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

   .business-card-list-item-text a, a:visited, a:hover, a:active, a:focus {
        text-decoration: none !important;
    }
  </style>
  